import { t } from '../../config/translations';
import { returnReasonOptions } from '../../utils/communSchemas';

export const returnSchema: any = {
  title: 'Customer',
  type: 'object',
  properties: {
    desi: {
      type: 'string',
      get title() {
        return t('schema.designation');
      },
      decorators: { search: true },
    },
    nart: {
      type: 'string',
      get title() {
        return t('schema.articleNumber');
      },
      decorators: { search: true },
    },
    qcde: {
      type: 'string',
      get title() {
        return t('schema.qtyOrdered');
      },
      decorators: { search: true },
    },
    qret: {
      type: 'string',
      get title() {
        return t('schema.qtyToReturn');
      },
      decorators: { search: true },
    },
    cact: {
      type: 'string',
      get title() {
        return t('schema.returnType');
      },
      uniforms: {
        checkboxes: true,
        options: [
          {
            get label() {
              return t('schema.credit');
            },
            value: 'ERM',
            color: 'blue',
          },
          {
            get label() {
              return t('schema.exchange');
            },
            value: 'ECS',
            color: 'blue',
          },
          {
            get label() {
              return t('schema.refund');
            },
            value: 'REM',
            color: 'blue',
          },
        ],
      },
      decorators: { search: true },
    },
    clit: {
      type: 'string',
      get title() {
        return t('schema.returnReason');
      },
      uniforms: {
        checkboxes: true,
        options: returnReasonOptions,
      },
      decorators: { search: true },
    },
    size: {
      type: 'string',
      get title() {
        return t('schema.requestedSize');
      },
      decorators: { search: true },
    },
    new_nart: {
      type: 'string',
      get title() {
        return t('schema.replacementArticle');
      },
    },
  },
  required: [],
};
